import {DrugItemFormDialogsIds} from '@/modules/drug-catalog/constants'
import {StabilityRuleFormDialog} from '@/modules/drug-catalog/stability-rules/components/stability-rule-form-dialog'
import {dialog} from '@cypro/ui/components'
import {ComponentProps} from 'react'

const dialogId = DrugItemFormDialogsIds.stabilityRule

export function openStabilityRuleFormDialog(props: ComponentProps<typeof StabilityRuleFormDialog>) {
  try {
    dialog.remove(dialogId)
  } catch {}

  return dialog.open(dialogId, {
    scrollBehavior: 'inside',
    size: 'cover',
    children: <StabilityRuleFormDialog {...props} onCancel={closeStabilityRuleFormDialog} />,
    contentProps: {
      overflow: 'hidden',
      maxWidth: '6xl',
    },
  })
}

export function closeStabilityRuleFormDialog() {
  return dialog.close(dialogId)
}
